module.exports = __webpack_public_path__ + "static/theme-0510f47f7852ce867f1680dfa2b047a4.png";